module.exports = __webpack_public_path__ + "img/ledger.029667b4.svg";